import { render, staticRenderFns } from "./PastEventsPage.vue?vue&type=template&id=4e410677&"
import script from "./PastEventsPage.vue?vue&type=script&lang=js&"
export * from "./PastEventsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports